import React, {useState} from "react";
import { useParams } from 'react-router-dom';
import AppBar from "../components/app_bar/AppBar";
import Drawer from "../components/Drawer";
import { 
    Typography, CssBaseline, Box, Toolbar, Grid, useMediaQuery,
    Dialog, DialogTitle, DialogContent, DialogContentText,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import ResponsiveCard from "../components/request_topic/ResponsiveCard";

import * as CONSTANTS from "../constants"


const RequestTopic = () => {

    const [username, ] = useState(localStorage.getItem('username'));
    let {lang} = useParams();

    document.title = `${CONSTANTS.DRAWER.REQUEST_TOPIC[lang]} - Wotagei Zone`

    const [drawerOpen, setDrawerOpen] = useState(false);
    const handleDrawerOpen = (open) => {
        if (open === undefined) {
            setDrawerOpen(!drawerOpen)
        } else {
            setDrawerOpen(open);
        }
    }

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Mobile detection

    return (
        <Box>
            <CssBaseline />
            <AppBar lang={lang} handleDrawerOpen={handleDrawerOpen}/>
            <Box sx={{ display: 'flex' }}>
                <Drawer lang={lang} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
                <Box component="main" sx={{ flexGrow: 1, p: isMobile ? 1 : 3, display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '100vh', width: '100%' }}>
                    <Toolbar />
                    <Box sx={{ width: '100%', mt: 2 }}>
                        {
                            username?
                            <></>
                            :
                            <Box sx={{ width: '100%' }}>
                                <Dialog 
                                    open={true}
                                    sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title" fontWeight="bold">
                                        {CONSTANTS.REQUEST_TOPIC.DIALOG.TITLE[lang]}
                                    </DialogTitle>
                                    <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                        {CONSTANTS.REQUEST_TOPIC.DIALOG.CONTENT[lang]}
                                        </DialogContentText>
                                    </DialogContent>
                                </Dialog>
                            </Box>
                        }
                        <Typography 
                            variant="h5" 
                            sx={{
                                textAlign: 'center',
                                fontWeight: 'bolder',
                                mb: 4,
                                mt: 2,
                                letterSpacing: 2
                            }}
                        >
                            {CONSTANTS.DRAWER.REQUEST_TOPIC[lang].toUpperCase()}
                        </Typography>
                        {/* Card Grouping - vertical stack, centered, full width on mobile */}
                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                            <ResponsiveCard 
                                title={CONSTANTS.DRAWER.WAZAREN[lang]}
                                description={CONSTANTS.REQUEST_TOPIC.HOME.WAZAREN_MSG[lang]}
                                button1={{text: CONSTANTS.REQUEST_TOPIC.HOME.NEW_WAZAREN[lang], link: username? `/${lang}/request-topic/wazaren/new/`: ''}}
                                button2={{text: CONSTANTS.REQUEST_TOPIC.HOME.UPDATE_WAZAREN[lang], link: username? `/${lang}/request-topic/wazaren/update/`: ''}}
                                imageUrl={"/assets/request-topic/wazaren.jpg"}
                            />
                            <ResponsiveCard 
                                title={CONSTANTS.DRAWER.WOTAGEISHI[lang]}
                                description={CONSTANTS.REQUEST_TOPIC.HOME.WOTAGEISHI_MSG[lang]}
                                button1={{text: CONSTANTS.REQUEST_TOPIC.HOME.NEW_WOTAGEISHI[lang], link: username? `/${lang}/request-topic/wotageishi/new/`: ''}}
                                button2={{text: CONSTANTS.REQUEST_TOPIC.HOME.UPDATE_WOTAGEISHI[lang], link: username? `/${lang}/request-topic/wotageishi/update/`: ''}}
                                imageUrl={"/assets/request-topic/wotageishi.jpg"}
                            />
                            <ResponsiveCard 
                                title={CONSTANTS.DRAWER.ORGANIZATION[lang]}
                                description={CONSTANTS.REQUEST_TOPIC.HOME.ORGANIZATION_MSG[lang]}
                                button1={{text: CONSTANTS.REQUEST_TOPIC.HOME.NEW_ORGANIZATION[lang], link: username? `/${lang}/request-topic/organization/new/`: ''}}
                                button2={{text: CONSTANTS.REQUEST_TOPIC.HOME.UPDATE_ORGANIZATION[lang], link: username? `/${lang}/request-topic/organization/update/`: ''}}
                                imageUrl={"/assets/request-topic/organization.jpg"}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
 
export default RequestTopic;